const LoadingState = Object.freeze({
  LOADING: Symbol("loading"),
  LOADED: Symbol("loaded"),
  ERROR: Symbol("error"),
});

export default LoadingState;
